import React, { useEffect, useState } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import OTPInput from "otp-input-react";
import InputMask from "react-input-mask";
import axios from "axios";
import { useUserStore } from "../../store/User";
import { getUserByToken } from "../../app/apis/getApis";
import { trackOTPSent, trackOTPVerified } from "../../utility/UserEvents";

const OTPModal = ({ show, onHide, setOTPVerified, otpVerified ,shop_name}) => {
  const [phoneNumber, setPhoneNumber] = useState("");
  const [otp, setOtp] = useState("");
  const [otpSent, setOtpSent] = useState(false);
  const [validated, setValidated] = useState(false);
  const [isRegisteredUser, setIsRegisteredUser] = useState(false);
  const [otpError, setOTPError] = useState("");
  const [otpResendTimer, setOtpResendTimer] = useState(60);
  const { user, token, setUser, setToken } = useUserStore(
    (state: any) => state
  );

  // Format phone number
  const formatPhoneNumber = (rawNumber) => {
    if (rawNumber.length >= 4) {
      return `+92-${rawNumber.substring(2, 5)}-${rawNumber.substring(5)}`;
    }
    return rawNumber;
  };

  // Handle phone number input change
  const handleChange = (e) => {
    e.preventDefault();
    setValidated(false);
    const unmaskedValue = e.target.value.replace(/\D/g, "");
    const formattedValue = formatPhoneNumber(unmaskedValue);
    setPhoneNumber(formattedValue);
  };

  // Send OTP
  const handlePNSubmit = async (e) => {
    e.preventDefault();
    setValidated(true);
    if (phoneNumber.length === 15) {
      try {
        const response = await axios.post(
          `${process.env.NEXT_PUBLIC_MARKETPLACE_API_URL}/auth/send-otp`,
          { phone_number: phoneNumber }
        );

        setIsRegisteredUser(response.data.body.data.registeredUser);
        trackOTPSent( user?.uuid,phoneNumber,shop_name);
        setOtpSent(true);
        setOtpResendTimer(60); // Reset timer on new OTP send
      } catch (err) {
        console.error(err);
      }
    } else {
      alert("Invalid phone number");
    }
  };

  // Countdown timer for OTP resend
  useEffect(() => {
    let timer;
    if (otpSent && otpResendTimer > 0) {
      timer = setInterval(() => {
        setOtpResendTimer((prev) => prev - 1);
      }, 1000);
    }

    return () => clearInterval(timer);
  }, [otpSent, otpResendTimer]);

  // Resend OTP
  const OTPResend = async () => {
    if (otpResendTimer === 0) {
      try {
        await axios.post(
          `${process.env.NEXT_PUBLIC_MARKETPLACE_API_URL}/auth/send-otp`,
          { phone_number: phoneNumber }
        );
        setOtpResendTimer(60);
        setOTPError("")// Reset timer
      } catch (err) {
        console.error(err);
      }
    }
  };

  // Verify OTP
  const handleOtpSubmit = async (e) => {
    e.preventDefault();
    try {
      const payload = {
        phone_number: phoneNumber,
        otp: +otp,
      };

      if (!isRegisteredUser) {
        payload.first_name = "guest";
        payload.last_name = "user";
      }
      const response = await axios
        .post(
          `${process.env.NEXT_PUBLIC_MARKETPLACE_API_URL}/auth/verify-otp`,

          payload
        )
        .then((response) => {
          setOTPVerified(true);
          if (response) {
            localStorage.setItem(
              "accessToken",
              response.data.body.data.accessToken
            );
            localStorage.setItem(
              "refreshToken",
              response.data.body.data.refreshToken
            );
            getUserByToken(response.data.body.data.accessToken).then(
              (response) => {

                setUser(response.data.body.data);
                setToken(response.data.body.data.accessToken);
              }
            );
            trackOTPVerified(user?.uuid,phoneNumber,shop_name);
            onHide();
          }
        })
        .catch((err) => {
          setOTPError(err?.response?.data?.body?.message?.replace(`"`, ""));
        });
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <Modal
      show={show}
      onHide={() => {
        onHide();
        setOtpSent(false);
        setPhoneNumber("")
        setOtp('')
        setOTPError("")
        setValidated(false)
      }}
      centered
    >
      {!otpSent ? (
        <Form noValidate validated={validated} onSubmit={handlePNSubmit}>
          <Modal.Body>
            <Modal.Header
              closeButton
              className="d-flex justify-content-center fw-bold "
            >
              Sign in to Contact the Seller
            </Modal.Header>
            <Form.Group controlId="phoneNumber">
              <InputMask
                className="w-100"
                mask="+\92-399-9999999"
                value={phoneNumber}
                name="phoneNumber"
                onChange={handleChange}
                required
              >
                <Form.Control
                  isValid={validated && phoneNumber.length === 15}
                  isInvalid={validated && phoneNumber.length < 15}
                  minLength={15}
                  className="border-dark w-75"
                  placeholder="Enter Your Phone Number"
                  type="tel"
                  required
                />
              </InputMask>
            </Form.Group>
            <div className="d-flex justify-content-center mt-2">
              <Button type="submit">Proceed</Button>
            </div>
          </Modal.Body>
        </Form>
      ) : (
        <>
          <Modal.Header
            closeButton
            className="d-flex justify-content-center fw-bold "
          >
            Sign in to Contact the Seller
          </Modal.Header>
          <Modal.Body className="d-flex justify-content-center">
            <Form onSubmit={handleOtpSubmit}>
              <OTPInput
                className="justify-content-center my-2"
                value={otp}
                onChange={setOtp}
                autoFocus
                OTPLength={4}
                otpType="number"
                disabled={false}
                secure
              />
              <div className="d-flex justify-content-around mt-2">
                <div
                  className="d-flex align-items-center"
                  style={{ justifyContent: "space-between" }}
                >
                  {otpResendTimer > 0 ? (
                    <span>{otpResendTimer} seconds remaining</span>
                  ) : (
                    <span>OTP not received yet?</span>
                  )}
                  <button
                    type="button"
                    disabled={
                      otpResendTimer > 0 ||
                      otpError === "Maximum attempts reached"
                    }
                    className="py-0 btn btn-outline-secondary"
                    style={{ marginLeft: "20px", height: "2rem" }}
                    onClick={OTPResend}
                  >
                    Resend
                  </button>
                </div>
              </div>
              {otpError && (
                <div className="text-danger text-center">{otpError}</div>
              )}
              <div className="mt-3 d-flex justify-content-center">
                <Button variant="outline-primary" type="submit">
                  Verify OTP
                </Button>
              </div>
            </Form>
          </Modal.Body>
        </>
      )}
    </Modal>
  );
};

export default OTPModal;
